import { render } from "./cardSvg.vue?vue&type=template&id=0bab63f8&scoped=true"
import script from "./cardSvg.vue?vue&type=script&lang=js"
export * from "./cardSvg.vue?vue&type=script&lang=js"

import "./cardSvg.vue?vue&type=style&index=0&id=0bab63f8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bab63f8"]])

export default __exports__